module.exports = __webpack_public_path__ + "img/h-page4-65.d8945cb3.png";